import { ColorLens } from "@mui/icons-material";
import { pink, red, blue, indigo, lightGreen, green, yellow } from "@mui/material/colors";
import { Box, IconButton, Popover, Typography } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles";
import useTheme from "@mui/styles/useTheme";
import React, { useState } from "react";

interface Props
{
    onSelect: (textColor: string | null, backColor: string | null) => void
}

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(1),
        boxSizing: "border-box",
        gap: theme.spacing(1),
        display: "flex",
        flexWrap: "wrap"
    },
    entry: {
        flexBasis: "32%",
        flexGrow: 1,
        cursor: "pointer",
        border: `1px solid ${theme.palette.divider}`,
        "& p": {
            margin: theme.spacing(1),
        }
    }
}));

export const paletteColors: string[] = [
    red[900],
    pink[600],
    blue[200],
    yellow[600],
    yellow[800],
    indigo[900],
    lightGreen[300],
    green[600],
    green[900],
];

export default function DefaultStyles({ onSelect }: Props)
{
    const classes = useStyles();
    const theme = useTheme();

    const defaultStyles = [
        { backColor: theme.palette.error.light },
        { backColor: theme.palette.warning.light },
        { backColor: theme.palette.success.light },
        { textColor: theme.palette.error.main },
        { textColor: theme.palette.warning.main },
        { textColor: theme.palette.success.main },
        ...paletteColors.map((color) => ({ backColor: color }))
    ];

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);
    const handleClose = () =>
    {
        setAnchorEl(null);
    };
    const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    {
        const backColor = event.currentTarget.dataset.back;
        const textColor = event.currentTarget.dataset.text;
        onSelect(textColor ?? null, backColor ?? null);
        handleClose();
    }
    return <Box>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
            <ColorLens />
        </IconButton>
        <Popover id={"Default Styles"} anchorEl={anchorEl} open={open} onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}>
            <Box className={classes.container}>
                {defaultStyles.map(({ textColor, backColor }, index) => <Box
                    key={index}
                    onClick={handleClick}
                    className={classes.entry}
                    data-text={textColor} data-back={backColor}
                    sx={{ color: textColor, backgroundColor: backColor }}>
                    <Typography>123</Typography>
                </Box>
                )}
            </Box>
        </Popover>
    </Box>
}